import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icon/ic_arrow_right.svg'


const _hoisted_1 = { class: "question-page" }
const _hoisted_2 = { class: "question-page__body" }
const _hoisted_3 = { class: "question-page__custom_container" }
const _hoisted_4 = { class: "question-page__custom_subcontainer_body" }
const _hoisted_5 = { class: "question-page__custom_subcontainer_date" }
const _hoisted_6 = { class: "question-page__custom_subcontainer_location" }
const _hoisted_7 = { class: "question-page__radio-group" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "question-page__custom_subcontainer_today" }
const _hoisted_10 = { class: "question-page__search" }
const _hoisted_11 = { class: "question-page__checkbox-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "question-page__question_container" }
const _hoisted_14 = { class: "question-page__radio-group" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "question-page__radio-group" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "question-page__radio-group" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "question-page__radio-group" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "question-page__radio-group" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "question-page__radio-group" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "question-page__radio-group" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "question-page__radio-group" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "question-page__radio-group" }
const _hoisted_31 = ["value"]

import { ref } from 'vue';
//버튼 함수

export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionPage',
  setup(__props) {

const editInfo = () => {
  alert("정보수정");
}
const deleteInfo = () => {
  alert("삭제");
}
const checkExam = () => {
  alert("검진포탈 자격확인");
}
const sendExam = () => {
  alert("검진일자 공단전송");
}

//checkbox 옵션
const locationOptions = ['일반/생애', '영유아', '학생검진', '학교밖'];
const selectedLocation = ref([]);

//radio 검진장소 옵션
const examOptions = ['내원 검진', '출장 검진'];
const selectedExam = ref('');

//radio 문진표 옵션
const binaryOptions = ['예', '아니오'];
const ternaryOptions = ['예', '아니오', '모르겠다'];
const feedbackOptions = ['매우 좋음', '좋음', '보통', '나쁨', '매우 나쁨'];
const frequencyOptions = ['0회', '1회', '2회', '3회', '4회', '5회', '6회 이상'];
const selected1 = ref('');
const selected2 = ref('');
const selected3 = ref('');
const selected4 = ref('');
const selected5 = ref('');
const selected6 = ref('');
const selected7 = ref('');
const selected8 = ref('');
const selected9 = ref('');

//date 모델
const examDate = ref('');
const currentDayPatients = ref('');

//search 
const searchQuery = ref(""); //검색어
const performSearch= ()=> { //검색 함수
    alert(searchQuery.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "question-page__custom_subcontainer_top" }, [
          _createElementVNode("div", { class: "question-page__custom_subcontainer_top_button" }, " @@ "),
          _createElementVNode("div", { class: "question-page__custom_subcontainer_top_button" }, " @@ ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { class: "question-page__custom_subcontainer_row" }, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "question-page__title" }, [
              _createElementVNode("img", { src: _imports_0 }),
              _createTextVNode(" 선택된 검진 대상자 정보 ")
            ], -1)),
            _createElementVNode("div", { class: "question-page__custom_subcontainer_body_row" }, [
              _createElementVNode("div", {
                class: "question-page__custom_subcontainer_body_button",
                onClick: editInfo
              }, " 정보수정 "),
              _createElementVNode("div", {
                class: "question-page__custom_subcontainer_body_button",
                onClick: deleteInfo
              }, " 삭제 ")
            ])
          ]),
          _createElementVNode("div", { class: "question-page__custom_subcontainer_row" }, [
            _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"question-page__custom_subcontainer_information_text\"><div class=\"question-page__custom_subcontainer_row\"><div class=\"question-page__subtitle\"> • 이 름 박 민 송 </div><div class=\"question-page__subtitle\"> • 주민번호 970704-0000000 </div></div><div class=\"question-page__subtitle\"> • 전화번호 010-4100-8677 </div></div>", 1)),
            _createElementVNode("div", {
              class: "question-page__custom_subcontainer_body_button",
              onClick: checkExam
            }, _cache[15] || (_cache[15] = [
              _createTextVNode(" 검진포탈"),
              _createElementVNode("br", null, null, -1),
              _createTextVNode("자격확인 ")
            ]))
          ]),
          _createElementVNode("div", { class: "question-page__custom_subcontainer_row" }, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "question-page__title" }, [
              _createElementVNode("img", { src: _imports_0 }),
              _createTextVNode(" 검진 종류 : 일반 구강검진 ")
            ], -1)),
            _createElementVNode("div", {
              class: "question-page__custom_subcontainer_body_button",
              onClick: sendExam
            }, _cache[17] || (_cache[17] = [
              _createTextVNode(" 검진일자"),
              _createElementVNode("br", null, null, -1),
              _createTextVNode("공단전송 ")
            ]))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "question-page__title" }, [
              _createElementVNode("img", { src: _imports_0 }),
              _createTextVNode(" 검진일 ")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "exam-date",
              placeholder: "년 월 일",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((examDate).value = $event))
            }, null, 512), [
              [_vModelText, examDate.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "question-page__title" }, [
              _createElementVNode("img", { src: _imports_0 }),
              _createTextVNode(" 검진장소 ")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(examOptions, (option, index) => {
                return _createElementVNode("label", { key: index }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    value: option,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedExam).value = $event))
                  }, null, 8, _hoisted_8), [
                    [_vModelRadio, selectedExam.value]
                  ]),
                  _createTextVNode(" " + _toDisplayString(option), 1)
                ])
              }), 64))
            ])
          ])
        ]),
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "question-page__custom_subcontainer_body_button2_layout" }, [
          _createElementVNode("div", { class: "question-page__custom_subcontainer_body_button2" }, " @@ "),
          _createElementVNode("div", { class: "question-page__custom_subcontainer_body_button2" }, " @@ ")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "question-page__title" }, [
            _createElementVNode("img", { src: _imports_0 }),
            _createTextVNode(" 당일 구강검진 수검자 ")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            id: "current-date",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentDayPatients).value = $event))
          }, null, 512), [
            [_vModelText, currentDayPatients.value]
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "question-page__custom_subcontainer_today_button" }, " @@ ", -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locationOptions, (option, index) => {
              return _createElementVNode("label", { key: index }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: option,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedLocation).value = $event))
                }, null, 8, _hoisted_12), [
                  [_vModelCheckbox, selectedLocation.value]
                ]),
                _createTextVNode(" " + _toDisplayString(option), 1)
              ])
            }), 64))
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            class: "question-page__search-input",
            placeholder: "검색"
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ]),
          _createElementVNode("button", {
            class: "question-page__search-submit",
            onClick: performSearch
          }, "검색")
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "question-page__custom_subcontainer_footer" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[26] || (_cache[26] = _createTextVNode(" 문진표 ")),
        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "question-page__question_container_title" }, " ※ 치과병력과 구강건강인식도 관련 문항 ", -1)),
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 1. 최근 1년간 구강병 치료나 관리를 목적으로 치과병(의)원에 가신 적이 있습니까? ", -1)),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(binaryOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selected1).value = $event))
              }, null, 8, _hoisted_15), [
                [_vModelRadio, selected1.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ]),
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 2. 현재 당뇨병을 앓고 계십니까? ", -1)),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ternaryOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selected2).value = $event))
              }, null, 8, _hoisted_17), [
                [_vModelRadio, selected2.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ]),
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 3. 현재 심혈관질환을 앓고 계십니까? ", -1)),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ternaryOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selected3).value = $event))
              }, null, 8, _hoisted_19), [
                [_vModelRadio, selected3.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ]),
        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 4. 최근 3개월 동안, 치아나 잇몸 문제로 혹은 틀니 때문에 음식을 씹는 데에 불편감을 느끼신 적이 있습니까? ", -1)),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(binaryOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selected4).value = $event))
              }, null, 8, _hoisted_21), [
                [_vModelRadio, selected4.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ]),
        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 5. 최근 3개월 동안, 치아가 쑤시거나 욱신거리거나 아픈 적이 있습니까? ", -1)),
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(binaryOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selected5).value = $event))
              }, null, 8, _hoisted_23), [
                [_vModelRadio, selected5.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ]),
        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 6. 최근 3개월 동안, 잇몸이 아프거나 피가 난 적이 있습니까? ", -1)),
        _createElementVNode("div", _hoisted_24, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(binaryOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selected6).value = $event))
              }, null, 8, _hoisted_25), [
                [_vModelRadio, selected6.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ]),
        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 7. 스스로 생각하실 때에 치아와 잇몸 등 귀하의 구강건강이 어떤 편이라고 생각하십니까? ", -1)),
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(feedbackOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selected7).value = $event))
              }, null, 8, _hoisted_27), [
                [_vModelRadio, selected7.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ]),
        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "question-page__question_container_title" }, " ※ 구강건강 습관(설탕섭취, 구강위생, 불소이용, 흡연) 관련 문항 ", -1)),
        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 8. 치아 닦는 방법을 치과나 보건소에서 배운 적이 있습니까? ", -1)),
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(binaryOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selected8).value = $event))
              }, null, 8, _hoisted_29), [
                [_vModelRadio, selected8.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ]),
        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "question-page__question_container_subtitle" }, " 9. 어제 하루 동안 치아를 몇 번 닦으셨습니까? ", -1)),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(frequencyOptions, (option, index) => {
            return _createElementVNode("label", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selected9).value = $event))
              }, null, 8, _hoisted_31), [
                [_vModelRadio, selected9.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option), 1)
            ])
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})